import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import { EditNonSerializedInventoryItem } from './EditNonSerializedInventoryItem'
import { DeleteNonSerializedInventoryItem } from './DeleteNonSerializedInventoryItem'
const getRowStyle = (item, rowIndex) => {
  const style = {}

  if (item.available_quantity === 0) {
    style.borderLeft = '10px solid Black'
    return style
  }
  if (item.available_quantity < 10) {
    style.borderLeft = '10px solid Red'
    return style
  }
  if (item.available_quantity < 25) {
    style.borderLeft = '10px solid Orange'
    return style
  }

  style.borderLeft = '10px solid Green'
  return style
}

export const NonSerializableDataGrid = ({
  results,
  descriptions,
  consignmentsTypes,
  page_size,
  current,
  count,
  onFilter,
  handleTableChange,
  children,
  hiddenRowKeys,
  onError,
  getData,
  onDelete,
}) => {
  const actionFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <ReactBootstrap.Dropdown>
        <ReactBootstrap.Dropdown.Toggle
          variant="dark"
          size="sm"
        ></ReactBootstrap.Dropdown.Toggle>
        <ReactBootstrap.Dropdown.Menu>
          <EditNonSerializedInventoryItem
            title={'Edit Non Serialized Inventory Entry' + current}
            onSubmit={getData}
            onError={onError}
            nonSerializedInventoryItem={row}
          />
          <DeleteNonSerializedInventoryItem
            onDelete={onFilter}
            onError={onError}
            nonSerializedInventoryItem={row}
          />
        </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>
    )
  }

  const columns = [
    {
      dataField: 'organization_code',
      searchFieldKey: 'organization',
      text: 'Organization',
      type: 'string',
      searchFieldType: 'text',
    },
    {
      dataField: 'description',
      text: 'Description',
      options: descriptions,
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'select',
    },
    {
      dataField: 'part_number',
      text: 'Part Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'string',
    },
    {
      dataField: 'consignment_type',
      text: 'Consignment Type',
      options: consignmentsTypes,
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'select',
    },

    {
      dataField: 'quantity',
      text: 'Quantity',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'available_quantity',
      text: 'Available Quantity',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'consumed_quantity',
      text: 'Consumed Quantity',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
          {
      dataField: 'created_by',
      text: 'Created By',
      type: 'string',
      formatter:  function (cell, row) {
          return <div className="text-left"> {cell==="Vivek Srivastava"?'N/A':cell} </div>
      },
      searchFieldType: 'text',

    },
    {
      dataField: 'created_at',
      text: 'Created On',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'date',
    },
              {
      dataField: 'url',
      text: 'Change Log',
      formatter: components.ChangeLogFormatter,
    },
    {
      dataField: 'is_deleted',
      text: '',
      isDummyField: true,
      formatter: actionFormatter,
    },
  ]

  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>
            Non Serialized Inventory
          </ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-white text-end" xs={6}>
            <components.Slider
              size="sm"
              sliderWidth={"20vw"}
              title={components.ICONS.SEARCH}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-1"> Non Serialized Inventory</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>
            {children}
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          rowStyle={getRowStyle}
          keyField="url"
          data={results || []}
          sizePerPage={page_size || 10}
          current={current || 1}
          page={current}
          columns={columns}
          count={count || 0}
          onTableChange={handleTableChange}
          hiddenRows={hiddenRowKeys}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
